import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InboxInfoDrawerService {
  private isOpen$$ = new BehaviorSubject<boolean>(false);
  isOpenDrawer$ = this.isOpen$$.asObservable();

  public toggle(): void {
    this.isOpen$$.next(!this.isOpen$$.value);
  }

  public setIsOpen(isOpen: boolean): void {
    this.isOpen$$.next(isOpen);
  }
}
